/**
 * Re-export of Prisma enums for type consistency
 * Add explicit exports as needed for better type checking
 */
export {
  AppointmentStatus, // Status of appointment bookings
  ArticleStatus, // Publication status of articles
  Currency, // Supported currency codes
  Language, // Supported language codes
  MediaPlacement, // Placement options for media items
  MediaType, // Types of media (image, video, etc)
  NotificationType, // Types of system notifications
  OrderStatus, // Status of commerce orders
  PaymentStatus, // Status of payment transactions
  PaymentType, // Types of payment methods
  ProjectStatus, // Status of user projects
  UnitOfMeasure, // Product measurement units
  UserRole, // User permission roles
  VehicleType // Types of vehicles
} from '@prisma/client';

